module.exports = __webpack_public_path__ + "fdb3fafc523e06f4e3493efb8824dc6e.svg";